import React from 'react';

const FisioServices = () => {
  const services = [
    {
      title: "Masaje de Descarga",
      description: "Terapia profunda para liberar tensión muscular y mejorar la recuperación. Ideal para deportistas y personas con estrés.",
      price: "500 pesos",
      icon: (
        <svg className="w-10 h-10 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.001 12.001 0 002.92 12c0 3.072 1.188 5.979 3.246 8.112A12.006 12.006 0 0012 21.001c3.072 0 5.979-1.188 8.112-3.246A12.006 12.006 0 0021.001 12c0-3.072-1.188-5.979-3.246-8.112z"></path>
        </svg>
      )
    },
    {
      title: "Ajuste Quiropráctico",
      description: "Corrección de desalineaciones vertebrales para mejorar la función nerviosa y aliviar dolores de espalda y cuello.",
      price: "400 pesos",
      icon: (
        <svg className="w-10 h-10 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
        </svg>
      )
    },
    {
      title: "Sesión de Fisioterapia",
      description: "Tratamiento integral para diversas afecciones musculoesqueléticas, neurológicas y post-quirúrgicas.",
      price: "500 pesos",
      icon: (
        <svg className="w-10 h-10 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.747 0-3.332.477-4.5 1.253"></path>
        </svg>
      )
    },
    {
      title: "Masaje de Descarga (Espalda o Piernas)",
      description: "Sesión enfocada en zonas específicas para alivio rápido de la tensión y fatiga muscular.",
      price: "300 pesos / 30 min",
      icon: (
        <svg className="w-10 h-10 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
        </svg>
      )
    },
    {
      title: "Electroterapia",
      description: "Aplicación de corrientes eléctricas para reducir el dolor, la inflamación y promover la recuperación de tejidos.",
      price: "250 pesos / 20 min",
      icon: (
        <svg className="w-10 h-10 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
        </svg>
      )
    }
  ];

  const promotions = [
    { sessions: 3, price: 1200, description: "3 sesiones de Fisioterapia" },
    { sessions: 5, price: 2000, description: "5 sesiones de Fisioterapia" },
    { sessions: 10, price: 3500, description: "10 sesiones de Fisioterapia" }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Nuestros Servicios y Precios</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 text-center transform hover:-translate-y-2">
              <div className="flex justify-center items-center mb-4">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <p className="text-blue-600 text-2xl font-bold">{service.price}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center bg-blue-100 p-8 rounded-xl shadow-lg">
          <h3 className="text-3xl font-bold text-blue-800 mb-4">¡Servicio a Domicilio Disponible!</h3>
          <p className="text-blue-700 text-lg">
            Llevamos la fisioterapia a la comodidad de tu hogar u oficina. Consulta disponibilidad y costos adicionales.
          </p>
        </div>

        <h2 className="text-4xl font-bold text-center text-gray-800 mt-16 mb-12">Promociones Especiales</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {promotions.map((promo, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg border-2 border-blue-500 text-center transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold text-blue-700 mb-3">{promo.sessions} Sesiones</h3>
              <p className="text-gray-700 text-lg mb-4">{promo.description}</p>
              <p className="text-blue-600 text-4xl font-extrabold">{promo.price} pesos</p>
              <p className="text-gray-500 mt-2">¡Ahorra al comprar en paquete!</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FisioServices;